import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { personsGetAllQuery } from '../../api/index.js'
import { Button } from '../../common/Button.tsx'
import { FormCompactInput } from '../../common/form/formcompactinput.jsx'
import { FormCompactSelect } from '../../common/form/formcompactselect.jsx'
import { EyeIconSmall, MiniFilterIcon } from '../../common/icons.jsx'
import { useGetAbscenceTypesOptionsOnlyActive } from '../personalprofile/newabscencemodal/useGetAbscenceTypesOptionsOnlyActive.ts'

const statusesOptions = (t) => [
	{ label: t('Open'), value: 'OPEN' },
	{ label: t('Approved'), value: 'APPROVED' },
	{ label: t('Rejected'), value: 'REJECTED' },
	{ label: t('Done'), value: 'DONE' },
]

export const CalendarFilters = ({ resetPersonsList, submitForm }) => {
	const { t } = useTranslation()
	const form = useFormContext()
	const { options: abscenceOptions } = useGetAbscenceTypesOptionsOnlyActive()
	const personsQuery = useQuery(personsGetAllQuery).data
	const persons = personsQuery?.data

	const usersWithSupervisors = persons?.flatMap((user) => {
		const options = []
		const supervisor1 = user?.controlDetails?.supervisor
		const supervisor2 = user?.controlDetails?.supervisor2

		if (supervisor1?.personName && supervisor1?.personNumber) {
			options.push({ label: supervisor1.personName, value: supervisor1.personNumber })
		}

		if (supervisor2?.personName && supervisor2?.personNumber) {
			options.push({ label: supervisor2.personName, value: supervisor2.personNumber })
		}

		return options
	})
	const supervisorsList =
		usersWithSupervisors &&
		Array.from(new Set(usersWithSupervisors.map((supervisor) => JSON.stringify(supervisor)))).map((supervisor) =>
			JSON.parse(supervisor),
		)

	const resetFilters = () => {
		form.reset()
		resetPersonsList()
	}

	useEffect(() => {
		const subscription = form.watch(form.handleSubmit(submitForm))
		return () => subscription.unsubscribe()
	}, [form, submitForm])

	return (
		<div className="d-flex justify-content-between">
			<div className="d-flex gap-2">
				<FormCompactSelect
					name="causeCode"
					label={t('Event')}
					selectProps={{ placeholder: t('All') }}
					options={abscenceOptions}
					Icon={EyeIconSmall}
					isCauseCodes
				/>
				<FormCompactInput
					name="payGroup"
					inputProps={{ placeholder: t('All'), style: { width: '4rem' } }}
					label={t('PaymentGroup', 'Maksuryhmä')}
					Icon={EyeIconSmall}
				/>
				<FormCompactSelect
					name="supervisor"
					label={t('Supervisor')}
					selectProps={{ placeholder: t('All') }}
					options={supervisorsList || []}
					Icon={EyeIconSmall}
				/>
				<FormCompactSelect
					name="status"
					label={t('Status')}
					selectProps={{ placeholder: t('All') }}
					options={statusesOptions(t)}
					Icon={EyeIconSmall}
				/>
			</div>
			<Button variant="outline-secondary" className="d-flex align-items-center fw-bold" onClick={resetFilters}>
				<MiniFilterIcon />
				{t('ClearFilters', 'Tyhjennä suodattimet')}
			</Button>
		</div>
	)
}
